import { Link } from "react-router-dom";
import type { LiveItem } from "@/types";
import { formatViewers } from "@/utils/format";

interface LiveCardProps {
  live: LiveItem;
}

export default function LiveCard({ live }: LiveCardProps) {
  return (
    <Link
      to={`/live/${live.id}`}
      className="group block overflow-hidden rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors duration-300"
      data-product-shop
    >
      <div className="relative w-full aspect-video overflow-hidden">
        <img
          src={live.cover}
          alt={`${live.title} - ${live.streamer}`}
          title={`${live.title} - ${live.streamer}`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 inline-flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-label font-semibold text-background-50">
          <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-live-pulse" />
          {live.status === "online" ? "直播中" : "回放"}
        </span>
        <span className="absolute bottom-2 right-2 inline-flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] font-label text-background-50">
          <i className="ri-eye-line text-xs" />
          {formatViewers(live.viewers)}
        </span>
      </div>
      <div className="p-3.5 md:p-4">
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {live.title}
        </h3>
        <div className="mt-3 flex items-center gap-2">
          <span className="w-6 h-6 rounded-full overflow-hidden shrink-0 bg-background-200">
            <img
              src={live.avatar}
              alt={live.streamer}
              title={`${live.streamer} - 主播`}
              className="w-full h-full object-top object-cover"
            />
          </span>
          <span className="text-xs md:text-sm text-foreground-600 truncate">{live.streamer}</span>
        </div>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {live.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-label text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}